import { notificationConstants } from '../../_constants';
import { notificationServices } from '../../_services';
import { alertActions, confirmPromptActions, userActions, } from '../index';
export const notificationActions = {
    CreateNotification,
    GetNotificationLogs,
    UpdateNotification,
    GetAllNotifications,
    ClearAllNotifications,
    CreateWaivedChargesLog,
    ClearNotifications,
    CreateSQNotification,
}

function notificationFetching() { return { type: notificationConstants.NOTIFICATION_FETCHING } }
function notificationFetched() { return { type: notificationConstants.NOTIFICATION_FETCHED } }

function notificationSubmitting() { return { type: notificationConstants.NOTIFICATION_SUBMITTING } }
function notificationSubmitted() { return { type: notificationConstants.NOTIFICATION_SUBMITTED } }

function ClearAllNotifications() { return { type: notificationConstants.CLEAR_ALL_NOTIFICATIONS } }

function CreateNotification(payload) {
    return dispatch => {
        dispatch(notificationSubmitting());
        notificationServices.CreateNotification(payload)
            .then(
                success => {
                    dispatch(notificationSubmitted());
                    dispatch(GetNotificationLogs(payload.userId, payload.roleId));
                    dispatch(confirmPromptActions.hide());
                },
                error => {
                    dispatch(notificationSubmitted());
                    dispatch(alertActions.error(error.toString()));
                }
            )
    }
}

function GetNotificationLogs(userId, roleId) {
    return dispatch => {
        dispatch(notificationFetching());
        notificationServices.GetNotificationLogs(userId, roleId)
            .then(
                NotificationLogs => {
                    dispatch(success(NotificationLogs));
                    dispatch(notificationFetched());
                },
                error => {
                    dispatch(notificationFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    }
    function success(NotificationLogs) { return { type: notificationConstants.GET_NOTIFICATION_LOGS, NotificationLogs } }
}

// function UpdateNotification(payload, id) {
//     return dispatch => {
//         dispatch(notificationSubmitting());
//         notificationServices.UpdateNotification(payload, id)
//             .then(
//                 success => {
//                     dispatch(notificationSubmitted());
//                     dispatch(GetNotificationLogs());
//                 },
//                 error => {
//                     dispatch(notificationSubmitted());
//                     dispatch(alertActions.error(error.toString()));
//                 }
//             )
//     }
// }
function UpdateNotification(isViewed, id) {
    return dispatch => {
        dispatch(notificationSubmitting());
        dispatch(userActions.notallowLeavePage());
        notificationServices.UpdateNotification(isViewed, id)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(notificationSubmitted());
                    dispatch(GetNotificationLogs());
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(notificationSubmitted());
                    dispatch(alertActions.error(error.toString()));
                }
            )
    }
}

function GetAllNotifications(userId, roleId, skip, take) {
    return dispatch => {
        dispatch(notificationFetching());
        notificationServices.GetAllNotifications(userId, roleId, skip, take)
            .then(
                AllNotifications => {
                    dispatch(success(AllNotifications));
                    dispatch(notificationFetched());
                },
                error => {
                    dispatch(notificationFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    }
    function success(AllNotifications) { return { type: notificationConstants.GET_ALL_NOTIFICATIONS, AllNotifications } }
}
function CreateWaivedChargesLog(payload) {
    return dispatch => {
        dispatch(notificationSubmitting());
        dispatch(userActions.notallowLeavePage());
        notificationServices.CreateWaivedChargesLog(payload)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(notificationSubmitted());
                    dispatch(GetNotificationLogs(payload.userId, payload.roleId));
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(notificationSubmitted());
                    dispatch(alertActions.error(error.toString()));
                }
            )
    }
}
function ClearNotifications(userId, roleId) {
    return dispatch => {
        dispatch(notificationSubmitting());
        notificationServices.ClearNotifications(userId, roleId)
            .then(
                success => {
                    dispatch(notificationSubmitted());
                    dispatch(GetNotificationLogs(userId, roleId));
                },
                error => {
                    dispatch(notificationSubmitted());
                    dispatch(alertActions.error(error.toString()));
                }
            )
    }
}

function CreateSQNotification(payload) {
    return dispatch => {
        dispatch(notificationSubmitting());
        notificationServices.CreateSQNotification(payload)
            .then(
                success => {
                    dispatch(notificationSubmitted());
                    dispatch(GetNotificationLogs(payload.userId, payload.roleId));
                },
                error => {
                    dispatch(notificationSubmitted());
                    dispatch(alertActions.error(error.toString()));
                }
            )
    }
}